
import moment from 'moment'

export const isNotMatchingFilters = (filters, trip) =>
  !(isWithinDates(filters, trip) &&
  isMatchingFilters(filters, trip))


export const isWithinDates = (f, trip) =>{
  if (!f.start_year || !f.end_year) return true
  return moment(new Date(trip.date_formatted_dow))
    .isBetween(
      `${f.start_year}-${f.start_month}-${f.start_day}`,
      // '2010-10-19',
      `${f.end_year}-${f.end_month}-${f.end_day}`,
    )
}


export const isMatchingFilters = (filters, {
  purpose, income_source,
  start_place, end_place,
  vehicle_id, uncategorized=null,
  amount,
  institution_account_token_id
}) => {

  const matching = {
    uncategorized,
    vehicle_id,
    purpose,
    income_source,
    institution_account_token_id,
    place_token_id: start_place && start_place.token_id
      || end_place && end_place.token_id,
  }

  const newObj = {}
  Object.keys(filters).forEach(k=> newObj[k] = matching[k] )

  const newFilters = { ...filters }
  // return newObj
  if (income_source && !filters.income_source) {
    delete newObj.income_source
    delete newFilters.income_source
  }
  // trip doesnt have an uncategorized key so don't compare it
  delete newFilters.uncategorized
  delete newObj.uncategorized

  if (!filters.income_source && !filters.purpose && !filters.uncategorized) {
    delete newObj.income_source
    delete newFilters.income_source
    delete newObj.purpose
    delete newFilters.purpose
  }

  delete newFilters.start_day
  delete newFilters.start_month
  delete newFilters.start_year
  delete newFilters.end_day
  delete newFilters.end_month
  delete newFilters.end_year

  if (filters.transaction_type) {
    newObj.transaction_type = Number(amount)<0 ? 'Expense' : 'Revenue'
  }

  return JSON.stringify(newObj) == JSON.stringify(newFilters)
}



// WEBPACK FOOTER //
// ./src/models/selectors.js